import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from '@angular/core';

/**
 * Used to display a box with a message in it. must only contain one element because the icon will be created before it.
 */
@Directive({
  selector: '[appMessageBox]'
})
export class MessageBoxDirective implements OnInit, OnChanges {

  element: HTMLElement;
  type: string;
  icon: any;
  @Input("appMessageBox") messageType: string;

  constructor(el: ElementRef, private renderer: Renderer2) {
    this.element = el.nativeElement as HTMLElement;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.revert();
    this.generate();
  }

  generate(): void {
    if (!this.messageType) {
      this.revert();
      return;
    }
    this.icon = this.renderer.createElement("i") as HTMLElement;
    this.renderer.addClass(this.icon, "icon");
    this.renderer.addClass(this.icon, "fas");

    let iconType = "fa-";
    switch (this.messageType) {
      case "success":
        iconType += "check-circle";
        this.renderer.addClass(this.element, "success");
        break;
      case "error":
        iconType += "exclamation-circle";
        this.renderer.addClass(this.element, "error");
        break;
      case "warning":
        iconType += "exclamation-triangle";
        this.renderer.addClass(this.element, "warning");
        break;
      case "info":
      default:
        iconType += "info-circle";
        this.renderer.addClass(this.element, "info");
        break;
    }
    this.renderer.addClass(this.icon, iconType);

    this.renderer.addClass(this.element, "message-box");
    this.renderer.addClass(this.element, "margin-tb-1");
    this.renderer.addClass(this.element, "mat-elevation-z1");

    this.renderer.insertBefore(this.element, this.icon, this.element.firstChild);
  }

  revert(): void {
    if (!this.icon) {
      return;
    }
    this.renderer.removeChild(this.element, this.icon);
    this.renderer.removeClass(this.element, "success");
    this.renderer.removeClass(this.element, "error");
    this.renderer.removeClass(this.element, "warning");
    this.renderer.removeClass(this.element, "info");
    this.renderer.removeClass(this.element, "message-box");
    this.renderer.removeClass(this.element, "margin-tb-1");
    this.renderer.removeClass(this.element, "mat-elevation-z1");
  }

  ngOnInit(): void {

  }

}
